import type { StudioApiClient } from "../../../api.js";
import { RelaunchPreviewPanel } from "../../../RelaunchPreviewPanel.js";

export function V10RelaunchPanel({
  api,
  claimId,
}: {
  readonly api: StudioApiClient;
  readonly claimId: string | null;
}) {
  return (
    <div className="v10-scan-embedded-panel" aria-label="Relaunch preview">
      <RelaunchPreviewPanel api={api} claimId={claimId} />
    </div>
  );
}
